define.alias("shared/components/shared/ui/error-banner", "calendar/components/shared/ui/error-banner");